export const setListaUnidades = (state, payload) => {
    state.listaUnidades = payload;
}

export const setUnidadeSelecionada = (state, payload) => {
    state.unidadeSelecionada = payload;
}

export const setListagemEnfermarias = (state, payload) => {
    state.listagemEnfermarias = payload;
}

export const setEnfermariaSelecionada = (state, payload) => {
    state.enfermariaSelecionada = payload;
}

export const setFiltroCodEnfermaria = (state, payload) => {
    state.filtroCodEnfermaria = payload;
}